module.exports = {"150123100":"城关镇","150123101":"盛乐镇","150123102":"新店子镇","150123103":"巧什营镇","150123203":"舍必崖乡","150123205":"大红城乡","150123206":"羊群沟乡","150123207":"黑老夭乡","150123400":"盛乐经济工业园区","150123401":"内蒙古和林格尔新区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/150123.json
// module id = 485
// module chunks = 0